// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function DepositError({ width = "70px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 70"
      width={width}
      {...props}
    >
      <g transform="translate(-526 -878)">
        <path
          fill="#334d5c"
          d="M0,35A35,35,0,1,1,35,70,35,35,0,0,1,0,35Z"
          transform="translate(526 878)"
        />
        <path
          fill="#67aeba"
          d="M113.684,189.8H62.136a.536.536,0,0,0-.536.536v9.029a.536.536,0,0,0,.536.536h51.548a.536.536,0,0,0,.536-.536v-9.029A.536.536,0,0,0,113.684,189.8Z"
          transform="translate(473.09 722.879)"
        />
        <rect
          fill="#4b868c"
          width="46.088"
          height="4.796"
          transform="translate(537.963 915.331)"
        />
        <rect
          fill="#b9efbd"
          width="43.704"
          height="13.797"
          transform="translate(539.148 915.331)"
        />
        <path
          fill="#a5dba7"
          d="M93.2,208.6v4.289h43.718V208.6Z"
          transform="translate(445.948 706.731)"
        />
        <path
          fill="#91c691"
          d="M93.2,208.6v1.566h43.718V208.6Z"
          transform="translate(445.948 706.731)"
        />
        <path
          fill="#71ad71"
          d="M140.709,221.536V208.6h-.367v12.485H98.867V208.6H98.5v12.936Z"
          transform="translate(441.396 706.731)"
        />
        <g transform="translate(539.896 915.331)">
          <rect fill="#598e59" width="0.381" height="4.289" />
          <rect
            fill="#598e59"
            width="0.381"
            height="4.289"
            transform="translate(41.842)"
          />
          <rect
            fill="#598e59"
            width="0.381"
            height="2.723"
            transform="translate(0 1.566)"
          />
        </g>
        <rect
          fill="#4f7f4f"
          width="0.381"
          height="1.566"
          transform="translate(539.896 915.331)"
        />
        <rect
          fill="#598e59"
          width="0.381"
          height="2.723"
          transform="translate(581.738 916.897)"
        />
        <rect
          fill="#4f7f4f"
          width="0.381"
          height="1.566"
          transform="translate(581.738 915.331)"
        />
        <g transform="translate(553.537 915.331)">
          <path
            fill="#71ad71"
            d="M202.663,220.408a7.461,7.461,0,0,0,6.066-11.808H196.6a7.461,7.461,0,0,0,6.066,11.808Z"
            transform="translate(-195.2 -208.6)"
          />
          <path
            fill="#71ad71"
            d="M217.218,208.6h0Z"
            transform="translate(-203.703 -208.6)"
          />
        </g>
        <path
          fill="#598e59"
          d="M196.6,208.6a7.417,7.417,0,0,0-1.4,4.289h14.911a7.417,7.417,0,0,0-1.4-4.289Z"
          transform="translate(358.337 706.731)"
        />
        <path
          fill="#4f7f4f"
          d="M199.861,208.6a7.645,7.645,0,0,0-.861,1.566h13.839a7.027,7.027,0,0,0-.861-1.566Z"
          transform="translate(355.073 706.731)"
        />
        <path
          fill="#71ad71"
          d="M252.073,244.3a2.193,2.193,0,0,0,.4-1.312,1.858,1.858,0,0,0-.268-1.072,2.315,2.315,0,0,0-1.1-.719v3.738A1.564,1.564,0,0,0,252.073,244.3Z"
          transform="translate(310.323 678.73)"
        />
        <path
          fill="#86bc88"
          d="M253.851,208.967a2.507,2.507,0,0,1,.381,1.114l1.058-.183a3.2,3.2,0,0,0-.409-1.3H253.4A1.4,1.4,0,0,1,253.851,208.967Z"
          transform="translate(308.348 706.731)"
        />
        <path
          fill="#b9efbd"
          d="M229.637,211.448a2.055,2.055,0,0,0,.748.9,3.666,3.666,0,0,0,1.284.578v3.894a1.4,1.4,0,0,1-1.03-.719,3.72,3.72,0,0,1-.423-1.453l-1.016.226a3.921,3.921,0,0,0,.409,1.622,2.671,2.671,0,0,0,.818.959,3.135,3.135,0,0,0,1.241.409v1.227h.607v-1.241a2.284,2.284,0,0,0,1.735-.9,3.293,3.293,0,0,0,.677-2.13,3.347,3.347,0,0,0-.169-1.072,3.108,3.108,0,0,0-.451-.861,2.47,2.47,0,0,0-.776-.621,5.945,5.945,0,0,0-1.016-.367v-3.4h-.607v3.259a1.982,1.982,0,0,1-.987-.677,1.8,1.8,0,0,1-.3-1.058,1.778,1.778,0,0,1,.339-1.086,1.5,1.5,0,0,1,.508-.437h-1.467a3.143,3.143,0,0,0-.4,1.622A3.222,3.222,0,0,0,229.637,211.448Zm2.638,1.651a2.315,2.315,0,0,1,1.1.719,1.858,1.858,0,0,1,.268,1.072,2.1,2.1,0,0,1-.395,1.312,1.452,1.452,0,0,1-.988.621V213.1Z"
          transform="translate(329.134 706.817)"
        />
        <g transform="translate(539.148 915.331)">
          <path
            fill="#91c691"
            d="M112.964,208.6h0Z"
            transform="translate(-93.2 -208.6)"
          />
          <path
            fill="#91c691"
            d="M244.037,208.6Z"
            transform="translate(-222.383 -208.6)"
          />
        </g>
        <path
          fill="#b9efbd"
          d="M231.669,239.041v3.894a1.4,1.4,0,0,1-1.03-.719,3.72,3.72,0,0,1-.423-1.453l-1.016.226a3.921,3.921,0,0,0,.409,1.622,2.671,2.671,0,0,0,.818.959,3.135,3.135,0,0,0,1.241.409v1.227h.607v-1.241a2.284,2.284,0,0,0,1.735-.9,3.293,3.293,0,0,0,.677-2.13,3.347,3.347,0,0,0-.169-1.072,3.108,3.108,0,0,0-.451-.861.609.609,0,0,1-.085-.1h-2.751A1.961,1.961,0,0,0,231.669,239.041Zm.607.169a2.315,2.315,0,0,1,1.1.72,1.858,1.858,0,0,1,.268,1.072,2.1,2.1,0,0,1-.4,1.312,1.452,1.452,0,0,1-.987.621V239.21Z"
          transform="translate(329.134 680.705)"
        />
        <path
          fill="#a0d8a3"
          d="M234.408,221.815a5.946,5.946,0,0,0-1.016-.367v-1.834h-.607v1.679a1.981,1.981,0,0,1-.988-.677,1.761,1.761,0,0,1-.282-1.016H230.5v.056a2.988,2.988,0,0,0,.268,1.312,2.055,2.055,0,0,0,.748.9,4.994,4.994,0,0,0,.846.451H235.1A2.66,2.66,0,0,0,234.408,221.815Z"
          transform="translate(328.017 697.283)"
        />
        <path
          fill="#b9efbd"
          d="M234.667,208.6Z"
          transform="translate(325.698 706.731)"
        />
        <g transform="translate(558.503 915.331)">
          <rect
            fill="#86bc88"
            width="0.607"
            height="1.566"
            transform="translate(2.299)"
          />
          <path
            fill="#86bc88"
            d="M231.768,209.023a1.415,1.415,0,0,1,.494-.423H230.8a3.218,3.218,0,0,0-.4,1.566h1.016v-.042A1.929,1.929,0,0,1,231.768,209.023Z"
            transform="translate(-230.4 -208.6)"
          />
        </g>
        <g transform="translate(555.749 888.442)">
          <path
            fill="none"
            stroke="#67aeba"
            strokeWidth="2"
            d="M2540.739,888.26l5.229-5.47,5.1,5.47"
            transform="translate(-2540.739 -882.79)"
          />
          <line
            fill="none"
            stroke="#67aeba"
            strokeWidth="2"
            y1="25.968"
            transform="translate(5.251 0.284)"
          />
        </g>
        <g transform="translate(554.15 896.019)">
          <circle fill="#f63f27" cx="6.774" cy="6.774" r="6.774" />
          <path
            fill="#fff"
            d="M45.515,43.717l2-2a.564.564,0,0,0-.8-.8l-2,2-2-2a.564.564,0,0,0-.8.8l2,2-2,2a.564.564,0,1,0,.8.8l2-2,2,2a.564.564,0,1,0,.8-.8Z"
            transform="translate(-37.942 -36.942)"
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/DepositError.js